export default __webpack_public_path__ + "img/031fc37e89204275a26e216bec851b23.png";